import { Component, Inject } from '@angular/core';
import { BulkProcessComponent } from '../bulk-process/bulk-process.component';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ScheduleResponse } from '../../../models/schedule.model';

@Component({
  selector: 'app-bulk-process-dialog',
  standalone: true,
  imports: [
    BulkProcessComponent,
    MatDialogModule,
  ],
  templateUrl: './bulk-process-dialog.component.html',
  styleUrl: './bulk-process-dialog.component.scss'
})
export class BulkProcessDialogComponent {

  schedule!: ScheduleResponse;

  constructor(
    public dialogRef: MatDialogRef<BulkProcessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.schedule = data.schedule;
   }

}
